module.exports = __webpack_public_path__ + "static/media/bag.5d6f91ab.png";